
/**
 * 환불 유형
 */
export type PostApiV1RefundsRequest200AllOfThreeDataRefundType = typeof PostApiV1RefundsRequest200AllOfThreeDataRefundType[keyof typeof PostApiV1RefundsRequest200AllOfThreeDataRefundType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiV1RefundsRequest200AllOfThreeDataRefundType = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
  AI_USAGE_BASED: 'AI_USAGE_BASED',
} as const;
